import { Container } from "@mui/material";
import React from "react";
import DesktopMenu from "./component/DesktopMenu";
import MobileMenu from "./component/MobileMenu";
import Twitter from "../../../assets/images/twitter.png"
import Telegram from "../../../assets/images/telegram.png"

const LockerMenu = (props) => {
  const menuList = [
    // You can pass 4 perameters for menu title, link, target and customClass

    {
      title: "Home",
      link: "/#home",
    },
    {
      title: "About",
      link: "#About",
    },
    {
      title: "Tokenomics",
      link: "#tokenomics",
    },
    {
      title: "Staking",
      link: "/stake",
    },
    {
      title: <img src={Twitter} />,
      link: " https://twitter.com/babyhex_pulse",
      target: "blank",
    },
    {
      title: <img src={Telegram} />,
      link: " https://t.me/babyhexpulse",
      target: "blank",
    },
  ];
  return (
    <div maxWidth="xl"
      data-aos="fade-zoom-in"
      data-aos-easing="ease-in"
      data-aos-delay="400"
      data-aos-duration="400"
      data-aos-offset="0">
      <DesktopMenu menuList={menuList} />
      <MobileMenu menuList={menuList} />
    </div>
  );
};

export default LockerMenu;
